<template>
    <div id="ws-modal" class="closable active" :class="scrollable?'scrollable':''" @keydown.esc="closeModal" ref="modalRef" tabindex="0" :data-name="name?'ws-modal-'+name:''">
        <div id="ws-modal-holder" @click="closeModal">
            <div id="ws-modal-window" @click.stop class="" style="width: 550px; height: auto;" :style="{'width': width ? width+'px' : defaultWidth+'px'}">
                <div id="ws-modal-close" class="close-button" @click="closeModal"></div>
                <div id="ws-modal-content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Modal",
    props: {
        name: String,
        width: Number,
        scrollable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            defaultWidth: 450
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        }
    },
    mounted() {
        this.$refs.modalRef.focus();
    },
    created() {
        document.body.classList.add('ws-modal');
        document.documentElement.classList.add('no-scroll-modal');
    },
    beforeDestroy() {
        if (!Object.values(this.modals).some(i => i === true)) {
            document.body.classList.remove('ws-modal');
            document.documentElement.classList.remove('no-scroll-modal');
        }
    },
    computed: {
        modals() {
            return this.$store.state.modals;
        },
        demo() {
            return this.$store.state.demo;
        }
    }
}
</script>

<style scoped>

</style>
